// extracted by mini-css-extract-plugin
module.exports = {"container":"TopChrono_container__Qor2w","text":"TopChrono_text__gR871","day":"TopChrono_day__wwUqC"};